var path = '/app/pages/codeNotFound/codenotfound.html';
var html = "<pre class=\"text-center my-4\">UNKNOWN CODE, ID: {{ctrl.code_id}}</pre>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/codeNotFound/codenotfound.html
// module id = 961
// module chunks = 0